import { Button, type ButtonProps } from '@mui/material';
import Link from 'next/link';
import { useFormContext } from 'react-hook-form';
import { interactionTypeRootPathName } from 'src/helpers';
import { InteractionType } from '@/common/types/interaction';
import {
  TrackInteractionsEvent,
  useTrackInteractionsAnalytics,
} from '$analytics/useTrackAnalytics/domains/interactions';
import type { FormData } from './types';

interface Props
  extends Omit<ButtonProps<typeof Link>, 'type' | 'onClick' | 'children'> {
  type: InteractionType;
  label?: string;
  eventContainer?: string;
}

export const CancelButton = ({
  type,
  label,
  eventContainer: customEventContainer,
  ...buttonProps
}: Props) => {
  const trackEvent = useTrackInteractionsAnalytics();
  const eventContainer = customEventContainer ?? `${type}_address_card`;
  const cancelUrl = `/${interactionTypeRootPathName(type)}`;
  const { getValues } = useFormContext<FormData>();
  const representationType =
    type === InteractionType.lease
      ? getValues('representationType')
      : undefined;

  const handleCancelButtonClick = () => {
    trackEvent(TrackInteractionsEvent.ClickCancelCreateTransaction, {
      eventContainer,
      representationType,
    });
  };

  return (
    <Button
      LinkComponent={Link}
      href={cancelUrl}
      onClick={handleCancelButtonClick}
      variant="outlined"
      size="large"
      sx={{ backgroundColor: 'white' }}
      {...buttonProps}
    >
      {label ?? 'Cancel'}
    </Button>
  );
};
